import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import classes from './TricolumnGraph.module.css';
import api from '../../../../Components/API/Api';
import { useUser } from '../../../../UserContext';

export default function TricolumnGraph() {
    const { user } = useUser();
    const [metrics, setMetrics] = useState({
        total_sales: 0,
        outstanding: 0,
        total_invoices: 0,
        overdue: 0,
        paid_total: 0,
        deposited_last_30: 0,
    });

    useEffect(() => {
        const fetchMetrics = async () => {
            try {
                const res = await api.get(`/v1/metrics/sales-invoice-metrics`);
                if (res?.data?.data) {
                    setMetrics((prev) => ({ ...prev, ...res.data.data }));
                }
            } catch (err) {
                console.error('Failed to fetch dashboard metrics', err);
            }
        };

        fetchMetrics();
    }, [user]);

    const formatCurrency = (value) => `₦${Number(value || 0).toLocaleString('en-NG', { minimumFractionDigits: 2 })}`;

    const unpaidTotal = Number(metrics.total_sales) || 0;
    const outstandingAmount = Number(metrics.outstanding) || 0;
    const paidTotal = Number(metrics.paid_total) || 0;
    const depositedLast30 = Number(metrics.deposited_last_30) || Number(metrics.depositedLast30) || 0;

    const overdueWidth = unpaidTotal > 0 ? Math.min((outstandingAmount / unpaidTotal) * 100, 100) : 0;
    const depositedWidth = paidTotal > 0 ? Math.min((depositedLast30 / paidTotal) * 100, 100) : 0;

    return (
        <section className={classes.entrjj}>
            <div className={classes.allkads}>
                <div className={`${classes.card} ${classes.invoicesCard}`}>
                    <div className={classes.cardHeader}>
                        <h3 className={classes.cardTitle}>Invoices</h3>
                    </div>

                    <div className={classes.metricRow}>
                        <div style={{ display: 'flex', justifyContent: 'space-between !important', width: "100%", gap: '6%' }} >
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <div className={classes.metricLarge}>₦0.00</div>
                                <div className={classes.metricLabel}>UNPAID</div>
                            </div>
                            <div className={classes.metricSmallLabel}>LAST 365 DAYS</div>
                        </div>
                        <div style={{ display: 'flex', display: 'flex', justifyContent: 'space-between', width: "100%", }}>
                            <div className={classes.progressLabelGroup}>
                                <div className={classes.metricHighlight}>{formatCurrency(outstandingAmount)}</div>
                                <div className={classes.progressLabel}>OVERDUE</div>
                            </div>

                            <div className={classes.metricRight}>
                                <div className={classes.metricLargeMuted}>₦0.00</div>
                                <div className={classes.metricSubtle}>NOT DUE YET</div>
                            </div>
                        </div>

                    </div>

                    <div className={classes.progressRow}>

                        <div className={classes.progressTrack}>
                            <span
                                className={`${classes.progressFill} ${classes.overdueFill}`}
                                style={{ width: `${overdueWidth}%` }}
                            />
                        </div>
                    </div>

                    <div className={classes.separator} />

                    <div className={classes.metricRow2}>
                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'space-between', width: "100%" }}>
                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'space-between', }}>
                                <div className={classes.metricLarge}>₦0.00</div>
                                <div className={classes.metricLabel}>PAID</div>
                            </div>

                            <div className={classes.metricSmallLabel}>LAST 30 DAYS</div>
                        </div>
                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'space-between', width: "100%", marginTop: '30px' }}>
                            <div className={classes.metricRightme}>
                                <div className={classes.metricLargeMuted}>{formatCurrency(unpaidTotal - outstandingAmount)}</div>
                                <div className={classes.metricSubtle}>DEPOSITED</div>
                            </div>



                            <div className={classes.metricRight}>
                                <div className={classes.metricLargeMuted}>{formatCurrency(paidTotal - depositedLast30)}</div>
                                <div className={classes.metricSubtle}>NOT DEPOSITED</div>
                            </div>
                        </div>


                    </div>

                    <div className={classes.progressRow}>

                        <div className={`${classes.progressTrack} ${classes.depositedTrack}`}>
                            <span
                                className={`${classes.progressFill} ${classes.depositedFill}`}
                                style={{ width: `${depositedWidth}%` }}
                            />
                        </div>
                    </div>
                </div>

                <div className={`${classes.card} ${classes.expensesCard}`}>
                    <div className={classes.cardHeader}>
                        <h3 className={classes.cardTitle}>Expenses</h3>
                        <div className={classes.filterBadge}>
                            <span>Last Month</span>
                            <span className={classes.caret}>▾</span>
                        </div>
                    </div>

                    <div className={classes.expensesContent}>
                        <div className={classes.expenseTotal}>
                            <div className={classes.metricLarge}>₦ 0.00</div>
                            <div className={classes.metricSubtle}>LAST MONTH</div>
                        </div>

                        <div className={classes.donutWrapper}>
                            <div className={classes.donut} aria-hidden />
                            <ul className={classes.legend} />
                        </div>
                    </div>
                </div>

                <div className={`${classes.card} ${classes.accountsCard}`}>
                    <div className={classes.cardHeader}>
                        <h3 className={classes.cardTitle}>Wallet</h3>
                        <Link to="/wallet" className={classes.cardsubTitle}>View Wallet</Link>
                    </div>

                    <div className={classes.accountBlock}>
                        <div className={classes.walletHeading }>Available Balance</div>
                        <div className={classes.accountRow}>
                            <span className={classes.walletLabel}>₦0.00</span>
                        </div>
                    </div>

                    <div className={classes.divider} />

                    <div className={classes.walletetBlock}>
                        <div className={classes.accountRow}>
                            <span className={classes.walletLabelii}>Ledger Balance</span>
                            <span className={classes.accountValue}>₦0.00</span>
                        </div>
                        <div className={classes.divider} />
                        <div className={classes.accountRow}>
                            <span className={classes.wallettLabeli}>Pending</span>
                            <span className={classes.accountValueMuted}>₦0.00</span>
                        </div>
                    </div>
                    <div className={classes.divider} />
                        <div className={classes.linksRow}>
                        <Link to="/wallet"><button className={classes.addMoneyButton}>Add Money</button></Link>
                        <button className={classes.withdrawButton}>Withdraw</button>
                    </div> 
                    <div>
                        <p className={classes.lastActivity}>Last activity: Today, 9:12am</p>
                    </div>
                    
                </div>
            </div>
        </section>
    );
}